var exports = {
  "K": "xaf9ae18d--82ee92--icon",
  "f": "xaf9ae18d--82ee92--expand",
};

module.exports = exports;
